import http from './api'
import {
  RestaurantStaffListResponse,
  RestaurantStaffInvitation,
  RestaurantStaffRole,
  RestaurantStaffInvitationStatus,
} from '../types/restaurantStaff'

class RestaurantStaffService {
  async listStaff(restaurantId: string): Promise<RestaurantStaffListResponse> {
    const response = await http.get(`/restaurants/${restaurantId}/staff`)
    return response.data
  }

  async removeStaff(restaurantId: string, userId: string): Promise<void> {
    await http.delete(`/restaurants/${restaurantId}/staff/${userId}`)
  }

  async invite(
    restaurantId: string,
    data: { recipientEmail: string; role: RestaurantStaffRole },
  ): Promise<RestaurantStaffInvitation> {
    const response = await http.post(
      `/restaurants/${restaurantId}/staff/invitations`,
      {
        ...data,
        // Used by the backend to build the email link back to this app.
        appUrl:
          typeof window !== 'undefined' ? window.location.origin : undefined,
      },
    )
    return response.data
  }

  async listRestaurantInvitations(
    restaurantId: string,
  ): Promise<RestaurantStaffInvitation[]> {
    const response = await http.get(
      `/restaurants/${restaurantId}/staff/invitations`,
    )
    return response.data
  }

  async getMyInvitations(): Promise<RestaurantStaffInvitation[]> {
    const response = await http.get('/restaurant-staff-invitations')
    return response.data
  }

  async respond(
    invitationId: string,
    status: Extract<RestaurantStaffInvitationStatus, 'accepted' | 'rejected'>,
  ): Promise<RestaurantStaffInvitation> {
    const response = await http.patch(
      `/restaurant-staff-invitations/${invitationId}`,
      { status },
    )
    return response.data
  }

  async markAllRead(): Promise<void> {
    await http.post('/restaurant-staff-invitations/read-all')
  }
}

const restaurantStaffService = new RestaurantStaffService()
export default restaurantStaffService
